import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import { connect } from "react-redux";
import { compose } from "underscore";
import { hideError } from "../../globalRedux/actions";

const StyledDialog = styled(Dialog)(() => ({
  "& .MuiDialog-scrollPaper": {
    padding: "0 16px",
  },
  "& .MuiDialog-paperFullWidth": {
    minWidth: "100%",
  },
}));

const AlertInfo = ({
  title,
  description,
  isOpen,
  isCS,
  isTimeout,
  isObject,
  handleClose,
  handleAction,
  fullWidthBtn,
  btnText,
  hideError,
  children,
  testId,
}) => {
  const split = text => {
    return text
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, str => str.toUpperCase());
  };

  const handleClick = () => {
    handleAction();
    hideError();
  };

  return (
    <StyledDialog
      fullWidth
      open={isOpen}
      onClose={handleClose}
      data-cy={testId}
    >
      <DialogTitle sx={{ padding: "24px 16px 0px" }}>
        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: "700",
            lineHeight: 1.4, //28px
            color: "#000",
          }}
        >
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ padding: "8px 16px 16px" }}>
        {!isObject ? (
          children ? (
            children
          ) : (
            <>
              <Typography sx={{ color: "#333" }}>{description}</Typography>
              {isTimeout && (
                <Typography sx={{ color: "#333", marginTop: "16px" }}>
                  Please try again later.
                </Typography>
              )}
              {isCS && (
                <Typography sx={{ marginTop: "16px" }}>
                  For{" "}
                  {title === "Account Verification"
                    ? "enquiries"
                    : "assistance"}
                  , kindly contact our{" "}
                  <span
                    style={{ color: "#1278cc" }}
                    onClick={() =>
                      window.my.navigateTo({
                        url: "/pages/link/link?url=" + encodeURIComponent(isCS),
                      })
                    }
                  >
                    Customer Care Centre
                  </span>{" "}
                  for assistance.
                </Typography>
              )}
            </>
          )
        ) : (
          <>
            {Object.keys(isObject)
              .filter(key => isObject[key])
              .map(key => {
                return (
                  <Typography sx={{ color: "#333" }}>
                    &#183; {split(key)}
                  </Typography>
                );
              })}
          </>
        )}
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "0px 16px 24px",
          margin: 0,
        }}
      >
        {fullWidthBtn ? (
          <button
            onClick={handleClick}
            style={{
              fontFamily: "FSElliotPro",
              fontSize: "16px",
              fontWeight: "normal",
              lineHeight: 1.5,
              width: "100%",
              backgroundColor: "#0076CF",
              border: "none",
              borderRadius: "100px",
              color: "white",
              padding: "12px 0",
              marginTop: "16px",
              boxShadow: "0 12px 24px -10px rgba(16, 109, 186, 0.6)",
            }}
          >
            {btnText || "Okay"}
          </button>
        ) : (
          <Button
            onClick={handleClick}
            sx={{
              color: "#0076CF",
              marginTop: "16px",
              padding: 0,
              textTransform: "capitalize",
              lineHeight: "20px",
              fontWeight: "700",
              fontSize: "16px",
              marginLeft: "0 !important"
            }}
          >
            {btnText || "OK"}
          </Button>
        )}
      </DialogActions>
    </StyledDialog>
  );
};

const withConnect = connect(
  () => ({}),
  { hideError }
);

export default compose(withConnect)(AlertInfo);
